import { useState } from "react";
import useCostCenters from "../../../hooks/useCostCenters";
import usePlanningProcesses from "../../../hooks/usePlanningProcesses";
import mapValues from "../../../util/mapValues";
import handleLoadSelectOptions from "../../../util/handleLoadSelectOptions";
import AsyncSelect from "react-select/async";
import useAxios from "../../../hooks/useAxios";
import { useFeedBack } from "../../../context/FeedBackContext";
import { useNavigate } from "react-router-dom";

const PlansCreate = () => {

    const { setCustomAlert } = useFeedBack();

    const navigate = useNavigate();

    const [data, setData] = useState({
        planning_process_id: '',
        cost_center_id: ''
    });

    const [{ costCenters, loading: loadingCostCenters }, getCostCenters] = useCostCenters({ options: { useCache: false } });

    const [{ planningProcesses, loading: loadingPlanningProcesses }, getPlanningProcesses] = usePlanningProcesses({ options: { useCache: false } });

    const [{ loading }, createRecord] = useAxios({ url: `/module-plans`, method: 'POST' }, { manual: true, useCache: false });

    const handleChange = (e) => {
        setData((oldData) => {
            return {
                ...oldData,
                [e.target.name]: e.target.value
            }
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (loading) return;

        createRecord({ data }).then(() => {
            setCustomAlert({
                show: true,
                severity: 'success',
                title: 'Operación Exitosa',
                message: 'El registro fue creado exitosamente.'
            });
            navigate(`/planes/listar`);
        });

    }

    return (
        <form className="card" onSubmit={handleSubmit}>
            <div className="card-header">
                <h6 className="card-title">
                    Crear plan
                </h6>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <div className="form-group ">
                            <label className="text-primary fw-bold">
                                Proceso de planificación
                            </label>
                            <AsyncSelect
                                isClearable
                                onFocus={() => {
                                    getPlanningProcesses({ params: { perPage: 50 } });
                                }}
                                defaultOptions={mapValues(planningProcesses, 'forYear')}
                                isLoading={loadingPlanningProcesses}
                                loadOptions={(e) => handleLoadSelectOptions(e, getPlanningProcesses, { perPage: 50 }, 'forYear')}
                                placeholder='Escriba el nombre para buscar...'
                                onChange={(e) => { handleChange({ target: { value: e?.value, name: 'planning_process_id' } }) }}
                            />
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="form-group ">
                            <label className="text-primary fw-bold">
                                Centro de costo
                            </label>
                            <AsyncSelect
                                isClearable
                                onFocus={() => {
                                    getCostCenters({ params: { perPage: 50 } });
                                }}
                                defaultOptions={mapValues(costCenters)}
                                isLoading={loadingCostCenters}
                                loadOptions={(e) => handleLoadSelectOptions(e, getCostCenters, { perPage: 50 })}
                                placeholder='Escriba el nombre para buscar...'
                                onChange={(e) => { handleChange({ target: { value: e?.value, name: 'cost_center_id' } }) }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-footer text-end">
                <button className="btn btn-secondary" type="button" onClick={() => navigate(-1)}>
                    Volver
                </button>
                <button disabled={loading} className="btn btn-primary ms-2">
                    {
                        loading ? 'Cargando' : 'Crear'
                    }
                </button>
            </div>
        </form>
    );
}

export default PlansCreate;